export default __webpack_public_path__ + "static/media/pneumatico_old.1b85be1d.png";